<!-- @format -->

<app-plan-header
  [allStudentPlans]="plans$ | async"
  [currentPlan]="selectedPlan$ | async"
  (selectPlan)="selectPlan($event)"
  [showHorizontalRule]="false" />
